import React, {
    useState,
    useEffect,

} from "react"
import { Tabs, Badge } from './ot'

const BaseCategoryMenu1 = ({
    data = [
        {
            key: "empty_draft",
            label: "進行中/歷史 空白建立",
            total: "0/0", // 雙數字
            badgeClassname: "bg-blue-100 text-blue-800"
        },
        {
            key: "ai_generated",
            label: "進行中/歷史 AI生成",
            total: "0/0",
            badgeClassname: "bg-purple-100 text-purple-800"
        },
        {
            key: "system_default",
            label: "進行中/歷史 系統預設",
            total: "5/0/500", // 三段數字
            badgeClassname: "bg-green-100 text-green-800"
        }],
    allLabel = "全部",
    showAllLabel = true,
    total = 0,
    defaultValue = "",
    onChange = () => { },
}, ref) => {
    const [currentKey, setCurrentKey] = useState(defaultValue)
    const transformTabsItems = (data) => {
        const items = [
            ...(showAllLabel?[{
                key: "",
                tab: (
                    <>
                        {allLabel}
                        <Badge variant="secondary" className="ml-1">
                            {total}
                        </Badge>
                    </>
                ),
            }]:[]),
            ...data.map((item) => ({
                key: item?.key,
                tab: (
                    <>
                        {item?.label ?? item?.key}
                        {item?.total !== undefined && (
                            <Badge
                                variant="secondary"
                                className={`ml-1 ${item?.badgeClassname ?? ""}`}
                                style={{
                                    backgroundColor: item?.light_mode_color,
                                    color: item?.dark_mode_color
                                }}
                            >
                                {item?.total}
                            </Badge>
                        )}
                    </>
                ),
            })),
        ]
        return items
    }

    const handleChange = (key) => {
        setCurrentKey(key)
        onChange(key)
    }

    return (
        <div style={{ overflowX: 'auto', width: '100%' }}>
            <Tabs
                items={transformTabsItems(data)}
                value={currentKey}
                onChange={handleChange}
            />
        </div>
    )
}

export default BaseCategoryMenu1
